import React from 'react';

export default function IconToastError({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0043 5C9.46086 5 9.03088 5.45983 9.06729 6.00203L9.43273 11.4437C9.45376 11.7568 9.71385 12 10.0276 12C10.3434 12 10.6044 11.7538 10.6228 11.4386L10.9418 5.99401C10.9734 5.4547 10.5445 5 10.0043 5ZM11 14C11 14.5523 10.5523 15 10 15C9.44772 15 9 14.5523 9 14C9 13.4477 9.44772 13 10 13C10.5523 13 11 13.4477 11 14Z"
        fill="#DE0707"
      />
    </svg>
  );
}
